export const getPermissionPageData = ({ state }) => state.permission.page;
export const getPermissionActionData = ({ state }) => state.permission.action;
export const getPermissionGroupData = ({ state }) => state.permission.group;
export const getUserSavedCCData = ({ state }) => state.permission.savedCC;
